import { INCREMENT_ID, RESET_ID, SET_ID } from '../constants'
import { createAction, handleActions } from 'redux-actions'
import { IsetId } from '../types/index'

// ACTION CREATORS
export const incrementId = createAction(INCREMENT_ID)
export const resetId = createAction(RESET_ID)
export const setId = createAction(SET_ID)

// REDUCERS
export default handleActions(
  {
    INCREMENT_ID: (state: number, action) => (
      state + 1
    ),

    RESET_ID: (state: number, action) => (0),

    SET_ID: (state: number, action: IsetId) => {
      return action.payload
    }
  },
  0
)



// WEBPACK FOOTER //
// ./src/ducks/animationId.ts